import { ActionButtons } from '@/components/molecules';
import { ModalWrapper } from '@/components/organisms';

interface AlertScoreModalProps {
	setShowModal: (showModal: boolean) => void;
	handleSubmit: () => void;
	handleCancel: () => void;
	textWarningArray: string[];
}

export const AlertScoreModal = ({ setShowModal, handleSubmit, handleCancel, textWarningArray }: AlertScoreModalProps) => {
	return (
		<ModalWrapper overlayClassName="z-10" className="max-w-[600px]" title="Score Warning" onClose={() => setShowModal(false)} closeOnOutsideClick>
			<div className="py-3">
				<p className="text-sm font-medium">The entered scores contain the following irregularities:</p>

				<ul className="space-y-2 pl-2 py-4">
					{textWarningArray.map((textItem, index) => (
						<li key={index} className="flex items-start gap-2.5">
							<div className="mt-1.5 size-2 shrink-0 rounded-full bg-gray-800" />
							<span className="text-sm text-gray-900">{textItem}</span>
						</li>
					))}
				</ul>

				<p className="text-sm font-medium">Would you still like to save these scores?</p>
			</div>

			<ActionButtons
				className="flex justify-end gap-3"
				closeButtonClassName="w-32"
				submitButtonClassName="min-w-36"
				onClose={handleCancel}
				onSubmit={handleSubmit}
				submitButtonText="Save Anyway"
				closeButtonText="Cancel"
				submitButtonDisabled={false}
			/>
		</ModalWrapper>
	);
};
